import { ModuleSetting, NewModuleSetting } from "@models";
import { ConfigModuleSetting } from "../configuration/types";
import { escapeCategoryId, getDefaultBudgetAmounts } from "./util";
import { useModuleSettingProduct } from "@hooks";

export function useDefaultConfigModuleSetting(
	moduleSetting: ModuleSetting | NewModuleSetting
): ConfigModuleSetting {
	const { product } = useModuleSettingProduct(moduleSetting);

	const amounts: ConfigModuleSetting["amounts"] = {};

	for (const variant of product.variants) {
		for (const cat of variant.budgetCategories) {
			const existingAmount = moduleSetting.amounts.find(
				(a) => a.category === cat.id
			);
			const escapedName = escapeCategoryId(cat.id);

			if (existingAmount) {
				amounts[escapedName] = {
					...existingAmount,
					enabled: true,
				};
			} else {
				amounts[escapedName] = {
					...getDefaultBudgetAmounts(cat),
					enabled: false,
				};
			}
		}
	}

	return { ...moduleSetting, amounts };
}
